import { post, put } from '../Services/http';
import { load as loadCart } from './Cart.action';
import { catchError } from './Error.action';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS =
    'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_CAMPAIGN_CODE = 'CHECKOUT_SET_CAMPAIGN_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION =
    'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_ACCEPT_NEWSLETTER = 'CHECKOUT_ACCEPT_NEWSLETTER';
export const CHECKOUT_CHOOSE_GENDER = 'CHECKOUT_CHOOSE_GENDER';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_DONE = 'CHECKOUT_SUBMIT_DONE';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_SET_SHIPPING_OPTION = 'CHECKOUT_SET_SHIPPING_OPTION';
export const CHECKOUT_GET_UNIFAUN = 'CHECKOUT_GET_UNIFAUN';
export const CHECKOUT_SET_ZIP = 'CHECKOUT_SET_ZIP'

export const setBusinessCustomer = isBusinessCustomer => ({
    type: CHECKOUT_SET_PRIVATE_CUSTOMER,
    payload: {
        isBusinessCustomer,
    },
});

export const setSignUp = signUp => ({
    type: CHECKOUT_SET_SIGN_UP,
    payload: {
        signUp,
    },
});

export const setAlternativeAddress = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'alternativeAddress',
        data: {
            [propName]: value,
        },
    },
});

export const setCustomerDetails = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'customerDetails',
        data: {
            [propName]: value,
        },
    },
});

export const setSelectedCompanyAddress = selectedCompanyAddressId => ({
    type: CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    payload: {
        selectedCompanyAddressId,
    },
});

export const setDelivery = unifaunOnChange => (dispatch, getState) => {
    unifaunOnChange && dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
            unifaunOnChange,
        },
    });

    const { payload } = getState().checkout;
    return put('/api/checkout/setDeliveryProvider', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            result.paymentWidget && dispatch(setPaymentWidget(result.paymentWidget));
        })
        .catch(ex =>
            dispatch(
                catchError(ex, error => {
                    console.log(error);
                    submitError(error);
                }),
            ),
        );
};

export const validateOrder = (callback) => (dispatch, getState) => {
    const { payload } = getState().checkout;

    return post('/api/klarnacheckout/validateOrder', payload)
        .then(response => response.json())
        .then(result => {
            callback({ should_proceed: result.shouldProceed, message: result.error })
        })
        .catch(ex => {
            callback({
                should_proceed: false, 
                error: 'An error occurred. Please try again, or recreate your order.' 
            })
        });
}

export const setShippingOption = shippingOption => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_SHIPPING_OPTION,
        payload: {
            klarnaSelectedShippingOption: shippingOption,
        },
    });
    const { payload } = getState().checkout;
    return put('/api/klarnacheckout/setShippingOption', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            if (result !== null && result.paymentWidget !== null) {
                dispatch(setPaymentWidget(result.paymentWidget));
            }
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const setSelectedCountry = data => (dispatch, getState) => {
    return put('/api/klarnacheckout/setSelectedCountry', { countryCode: data.country })
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const setCountry = systemId => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_COUNTRY,
        payload: {
            selectedCountry: systemId,
        },
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setCountry', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
            dispatch({
                type: CHECKOUT_SET_DELIVERY,
                payload: {
                    deliveryMethods: result.deliveryMethods,
                    selectedDeliveryMethod: result.selectedDeliveryMethod,
                },
            });
            dispatch({
                type: CHECKOUT_SET_PAYMENT,
                payload: {
                    paymentMethods: result.paymentMethods,
                    selectedPaymentMethod: result.selectedPaymentMethod,
                },
            });
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const setPayment = systemId => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
            selectedPaymentMethod: systemId,
        },
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setPaymentProvider', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));

            const shippingAddress = result.companyAddresses && result.companyAddresses.find((address) => address.addressType === 'Shipping');
            if (shippingAddress)
                dispatch(setZip(shippingAddress.zipCode))
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const reloadPayment = () => (dispatch, getState) => {
    const { paymentWidget, selectedPaymentMethod } =
        getState().checkout.payload;
    if (!paymentWidget) {
        return;
    }
    return dispatch(setPayment(selectedPaymentMethod));
};

export const setZip = (zip) => (dispatch, getState) => {
    const { zipCode } = getState().checkout.payload
    const localZip = zip ? zip : zipCode

    if (localZip) {
        dispatch({
            type: CHECKOUT_SET_ZIP,
            payload: {
                zipCode: zip ? localZip : new String(localZip), // To force reload if no argument was sent to the method
            },
        });
    }
}

const setPaymentWidget = paymentWidget => ({
    type: CHECKOUT_SET_PAYMENT_WIDGET,
        payload: {
            paymentWidget,
    },
});

export const setOrderNote = orderNote => ({
    type: CHECKOUT_SET_ORDER_NOTE,
    payload: {
        orderNote,
    },
});

export const acceptTermsOfCondition = acceptTermsOfCondition => ({
    type: CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    payload: {
        acceptTermsOfCondition,
    },
});

export const setCampaignCode = campaignCode => (dispatch, getState) => {
    dispatch(
        submitError({
            modelState: {
                campaignCode: undefined, // To reset errors
            },
        }),
    );

    dispatch({
        type: CHECKOUT_SET_CAMPAIGN_CODE,
        payload: {
            campaignCode,
        },
    });
};

export const submitCampaignCode = () => (dispatch, getState) => {
    const { payload } = getState().checkout;

    // Initial clear
    dispatch(
        submitError({
            modelState: {
                campaignCode: undefined,
            },
        }),
    );

    return put('/api/checkout/setCampaignCode', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
            // reset error of campaign code. (Used to detect success also.)
            dispatch(
                submitError({
                    modelState: {
                        campaignCode: [],
                    },
                }),
            );
        })
        .catch(ex => {
            dispatch(catchError(ex, error => submitError(error)));
            // restore the initial cart
            dispatch(loadCart());
        });
};

export const submit = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return _submit('/api/checkout', payload, dispatch);
};

export const verify = (url, orderId, payload) => (dispatch, getState) => {
    const model = getState().checkout.payload;
    model.orderId = orderId;
    model.payload = payload;
    return _submit(url, model, dispatch);
};

const _submit = (url, model, dispatch) => {
    return post(url, model)
        .then(response => response.json())
        .then(result => {
            dispatch(submitDone(result));
        })
        .catch(ex => {
            if (ex.response) {
                ex.response.json().then(error => {
                    dispatch(submitError(error));
                    dispatch(submitDone(null));
                    // reload the cart, it might be changed after validation
                    dispatch(loadCart());
                });
            } else {
                dispatch(submitError(ex));
            }
        });
};

export const submitRequest = () => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        isSubmitting: true,
        errors: [],
    },
});

export const submitDone = result => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        result,
        isSubmitting: false,
    },
});

export const submitError = error => ({
    type: CHECKOUT_SUBMIT_ERROR,
    payload: {
        error,
    },
});

//unifaun extended
export const getUnifaun = (settings, widget) => dispatch => {
    dispatch({
        type: CHECKOUT_GET_UNIFAUN,
        payload: {
            deliveriesSettings: settings,
        },
    });
    if (widget) {
        widget.disable();
        return post('/api/transportapi/unifaun/getDeliveryCheckouts', settings)
            .then(response => {
                return response.json();
            })
            .then(json => {
                dispatch(clearValidationError('unifaunOnChange'));
                return JSON.parse(json);
            })
            .catch(e => {
                console.error(`Error: ${e}`);
                return {
                    options: [],
                };
            })
            .then(widget.enable());
    }
};

export const chooseGender = (field, value) => (dispatch, getState) => {
    const { acceptNewsletter } = getState().checkout.payload;

    dispatch({
        type: CHECKOUT_CHOOSE_GENDER,
        payload: {
            male: field === 'Male' ? value : false,
            female: field === 'Female' ? value : false,
        },
    });

    return put('/api/newsletter/checkoutOptin', {
        gender: value ? field : null,
        acceptNewsletter: acceptNewsletter,
    });
};

export const acceptNewsletter = value => (dispatch, getState) => {
    const { male, female } = getState().checkout.payload;
    let gender = null;

    if (male) gender = 'Male';
    if (female || gender === null) gender = 'Female';

    dispatch({
        type: CHECKOUT_ACCEPT_NEWSLETTER,
        payload: {
            male: gender === 'Male' ? value : false,
            female: gender === 'Female' ? value : false,
            acceptNewsletter: value,
        },
    });

    return put('/api/newsletter/checkoutOptin', {
        gender,
        acceptNewsletter: value,
    });
};

export const makeBriqpayPurchaseDecision = decision => (dispatch, getState) => {
    const { payload } = getState().checkout;

    return post('/api/checkout/makeBriqpayPurchaseDecision', 
        { 
            model: payload, 
            decision: decision 
        })
        .catch((error) => {
            if (error.response) {
                error.response.json()
                .then(error => {
                    dispatch(submitDone(null));
                    // reload the cart, it might be changed after validation
                    dispatch(loadCart());
                    dispatch(reloadPayment())
                    dispatch(setZip(null))
                    setTimeout(() => {
                        dispatch(submitError(error));
                    }, 1000);
                });
            } else {
                dispatch(submitError(ex));
            }
        });
};

const clearValidationError = path => {
    return submitError({
        name: "ValidationError",
        path: path,
        errors: undefined
    })
}

export const setGoodsMarking = (propName, value) => (dispatch, getState) => {
    const { customerDetails } = getState().checkout.payload;

    const data = {
        ...customerDetails,
        [propName]: value,
    };

    dispatch({
        type: CHECKOUT_SET_CUSTOMER_INFO,
        payload: {
            key: 'customerDetails',
            data: data,
        }
    });
};

export const updateGoodsMarking = () => (dispatch, getState) => {
    const { customerDetails } = getState().checkout.payload;
    return put(`/api/checkout/setGoodsMarking?goodsMarking=${customerDetails.goodsMarking}`, {});
};